import type {StaticCanvas, Textbox, TPointerEvent} from '@postermywall/fabricjs-2';
import {Canvas} from '@postermywall/fabricjs-2';

interface EditSessionCaretPlacement {
  textbox: Textbox;
  /** The event that opened the session, when one did. */
  event: TPointerEvent | undefined;
  /** The page canvas; only an interactive one has the upper canvas element a pointer event hits. */
  canvas: Canvas | StaticCanvas;
  /** A freshly added item opens with its placeholder text selected so typing replaces it. */
  selectAllText: boolean;
}

/**
 * Where editing starts: a new item's text is selected whole; a click or tap on the canvas puts
 * the caret under the pointer, exactly where fabric's own click handling would; anything else
 * (a keyboard shortcut, an "Edit" button) parks the caret at the end with nothing selected.
 */
export const placeEditSessionCaret = ({textbox, event, canvas, selectAllText}: EditSessionCaretPlacement): void => {
  const upperCanvasElement = canvas instanceof Canvas ? canvas.upperCanvasEl : null;
  if (selectAllText) {
    textbox.selectAll();
    return;
  }
  if (event && upperCanvasElement !== null && event.target === upperCanvasElement) {
    textbox.setCursorByClick(event);
    return;
  }
  const end = textbox.text.length;
  textbox.setSelectionStart(end);
  textbox.setSelectionEnd(end);
};
